// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"e2d18f42","453":"9ed82018"}[chunkId] + ".chunk.js";
};